import { Box, Flex } from '@rebass/grid'
import * as React from 'react'
import { Text, TextArea } from 'src/elements'
import styled from 'styled-components'

const ToolbarContainer = styled(Flex).attrs({ justifyContent: 'flex-end' })`
  position: absolute;
  right: 8px;
  bottom: 8px;
`

const EditBlock = ({ onChange, onConfirm, onCancel, defaultValue }) => (
  <Flex flexDirection="column">
    <TextArea
      style={{
        borderColor: '#ececec',
        borderBottom: '28px solid #fff',
        boxShadow: '0px 1px 5px #ececec',
      }}
      rows={4}
      autoFocus={true}
      onChange={onChange}
      defaultValue={defaultValue}
    />
    <ToolbarContainer>
      <Box mr={3}>
        <Text.LabelGray onClick={onCancel}>取消</Text.LabelGray>
      </Box>
      <Box>
        <Text.LabelMain onClick={onConfirm}>確認</Text.LabelMain>
      </Box>
    </ToolbarContainer>
  </Flex>
)
export default EditBlock



// WEBPACK FOOTER //
// ./src/components/Reply/EditBlock.tsx